import { coreDefaultTheme, DottedProgressTheme } from '@kite-js/theme';
import colors from '@theme/priceline/theme-priceline/colors';

const dottedProgressTheme: DottedProgressTheme = {
    ...coreDefaultTheme.dottedProgress!,
    dotColors: [colors.blue[100], colors.blue[200], colors.blue[300], colors.blue[400], colors.blue[500]],
};

export default dottedProgressTheme;
